import type { Feature } from '#/domain/customerAccess/Feature'
import type { CustomerAccessRepository } from '#/domain/customerAccess/CustomerAccessRepository'

export class GetCustomerFeaturesUseCase {
  constructor(private readonly repository: CustomerAccessRepository) {}

  execute(customerId: string): Promise<Feature[]> {
    return this.repository.findFeaturesForCustomer(customerId)
  }
}
